/**
 * Total Number of policies, Policy Holders and Insured Persons
 */

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header.map(item => {
		return { wpx: 150 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template 05 - Total Number of policies, Policy Holders and Insured Persons"
	],
	["Number", "Standard Plan", "Flexi Plan"]
]

const rows = payload => [
	["Policies", countPolicies(payload), 0],
	["Policy Holders", countPolicyHolders(payload), 0],
	["Insured Persons", countPolicies(payload), 0]
]

const countPolicies = payload => {
	return payload.filter(policy => policy.status === "ISSUED").length
}

const countPolicyHolders = payload => {
	const otherPolicyHolders = payload
		.filter(policy => policy.status === "ISSUED")
		.map(policy =>
			policy.otherContractHolders !== null
				? policy.otherContractHolders.length
				: null
		)
		.reduce((a, b) => a + b)

	const primaryHolders = payload.filter(policy => policy.status === "ISSUED")
		.length

	return otherPolicyHolders + primaryHolders
}
